import format from "date-fns/format"
import { getHHmmFromDate } from "../utils"
import { NewIntervalHourReportDataSchema, NewManualHourReportDataSchema, NewTimerHourReportDataSchema } from "./schemas"
import type { HourReportFormState } from "../schemas"
import type { NewHourReportData } from "./schemas"

export class NewHourReportDataFactory {
  static createFromManualEntry(data: HourReportFormState): NewHourReportData {
    if (data.method !== "manual") {
      throw new Error("Data must be of method 'manual' to create new hour report data from manual")
    }

    return NewManualHourReportDataSchema.parse({
      ...data,
      date: format(new Date(data.date), "yyyy-MM-dd"),
      hours: data.hours + (data.minutes || 0) / 60, // Convert minutes to hours
    })
  }

  static createFromIntervalEntry(data: HourReportFormState): NewHourReportData {
    if (data.method !== "interval") {
      throw new Error("Data must be of method 'interval' to create new hour report data from interval")
    }

    const date = new Date(data.date)

    return NewIntervalHourReportDataSchema.parse({
      ...data,
      date: format(date, "yyyy-MM-dd"),
    })
  }

  static createFromTimerEntry(data: HourReportFormState): NewHourReportData {
    if (data.method !== "timer") {
      throw new Error("Data must be of method 'timer' to create new hour report data from timer")
    }

    const startTime = getHHmmFromDate({ date: new Date(data.timerStartTime!) })
    const endTime = getHHmmFromDate({
      date: new Date(data.timerEndTime!),
      midnightAs24Hour: true,
      convertEndOfDayToMidnight: true,
    })
    const hours = data.timerElapsedHours!

    return NewTimerHourReportDataSchema.parse({
      ...data,
      date: format(new Date(data.date), "yyyy-MM-dd"),
      startTime,
      endTime,
      hours,
    })
  }
}
